import { get } from 'lodash';

export const endUserAuthApiSelector = state => get( state, 'appConfig.END_USER_AUTH_API' );

export const newRelicHostNameSelector = state => get( state, 'appConfig.NEW_RELIC_HOSTNAME' );

export const newRelicApplicationIdSelector = state => get( state, 'appConfig.NEW_RELIC_APP_ID' );

export const navBarMessageSelector = state => get( state, 'appConfig.NAVBAR_MESSAGE' );
